import classNames from "classnames";
import Label from "@ingka/label";
import LabelWithToolTip from "../LabelWithTooltip/LabelWithToolTip";
import { useEffect, useState } from "react";

type Props = {
  id: string;
  labelText: string;
  toolTipText: string;
  value: string;
  disabled?: boolean;
  hasError?: boolean;
  onChange: (value: string | null) => void;
};

export const DateField = ({
  id,
  labelText,
  toolTipText,
  value,
  disabled,
  hasError,
  onChange,
}: Props) => {
  const [date, setDate] = useState(value || "");

  useEffect(() => {
    setDate(value || "");
  }, [value]);

  return (
    <div className="flex flex-col">
      <Label
        htmlFor={id}
        label={
          <LabelWithToolTip labelText={labelText} toolTipText={toolTipText} />
        }
      />
      <input
        id={id}
        type="date"
        className={classNames("date-form-field", {
          "date-form-field-disabled": disabled,
          "form-field-error": hasError,
        })}
        name={id}
        disabled={disabled}
        value={date}
        onChange={(e) => {
          const { value } = e.target;
          setDate(value);
        }}
        onBlur={(e) => onChange(e.target.value || null)}
      />
    </div>
  );
};

export default DateField;
